import { CurrentUserType } from '@/queries/current-user';
import { OrganizationUserRole } from '@/queries/graphql-types';
import { OrganizationMember } from '@/types/user';

export const isUserOrganizationAdmin = (currentUser: CurrentUserType): boolean => {
    const orgUsers: Array<OrganizationMember> = currentUser?.primaryOrganization?.organizationUsers || [];

    return orgUsers.some(({ role, user }) => user.id === currentUser.id && role === OrganizationUserRole.Admin);
};
